<template>
  <div class="mainCenterContainer assignWork">
    <searchBox :categoryId="$route.query.categoryId" :workTypeId="$route.query.workerId" @searchList="searchList"/>
    <div style="display: flex">
      <div class="paiHuo">
        <div v-loading="loadingGoods">
          <div v-if="ifHasProduct">
            <div class="mainContent" v-for="(item, index) in list" :key="index" @click="detail(item.id, item.isMyPub)">
              <div class="paiHuoBox">
                <div class="headImg">
                  <img class="headImg"
                       src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygwApplet/getJob/touxiang_default_lgsc.png"
                       v-if="!item.headImg">
                  <img :src="item.headImg" v-else class="headImg" @click.stop="imagePreview(item.headImg)">
                </div>
                <div class="person-info">
                  <div class="work-name">
                    {{ item.name }}
                  </div>
                  <div class="tag-div">
                    <el-tag class="isAuth" style="color: #10b96a !important;" v-if="item.isAuth === 1">
                      已实名
                    </el-tag>
                    <el-tag type="info" style="color: #cccccc; border-color: #cccccc;" color="#517fbd12"
                            v-if="item.isAuth === 0">未实名
                    </el-tag>
                    <el-tag v-if="item.type === 0">个人
                    </el-tag>
                    <el-tag v-if="item.type === 1">班组
                    </el-tag>
                    <el-tag v-if="item.type === 2">企业
                    </el-tag>
                  </div>
                </div>
              </div>
              <div class="informationBox">
                <template v-if="item.type === 2">
                  <el-col :span="8">
                    <div class="information">企业资质：{{ item.infos }}</div>
                  </el-col>
                  <el-col :span="16">
                    <div class="information">企业地址：{{ item.cityInfo }}</div>
                  </el-col>
                </template>
                <template v-else>
                  <el-col :span="8">
                    <div class="information">期望城市：{{ item.cityInfo }}</div>
                  </el-col>
                  <el-col :span="16">
                    <div class="information">我的工种：{{ item.infos }}</div>
                  </el-col>
                </template>
              </div>
              <div class="intro"> {{ item.content }}</div>

              <div class="btn-chat">
                <el-button type="primary" size="mini" round
                           style="width: 88px; height: 28px;font-size: 12px;border: 1px solid #37A1FFFF;background-color: #37A1FFFF">
                  立即沟通
                </el-button>
              </div>

              <span class="icon_zhiding" v-show="item.isTop === 1"></span>
            </div>
          </div>
          <div v-else class="noContent">
            <img src="../../assets/img/public/empty_icon.png">
            <div style="width: 100%; text-align: center">暂无内容</div>
          </div>
        </div>

        <pagination
          v-show="total > pageSize"
          :total="total"
          layout="prev, pager, next"
          :background="false"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="getAssignTaskList"
        />
      </div>
      <div class="rightContainer">
        <ul class="right-download">
          <li>
            <div class="right-download-div  right-download-app">
              <!-- <img :src="appQrCode"> -->
            </div>
          </li>
          <li>
            <div class="right-download-div right-download-xcx">
              <!-- <img :src="xcxQrCode"> -->
            </div>
          </li>
          <li>
            <div class="right-download-div right-download-wechat">
              <!-- <img :src="qunQrCode"> -->
            </div>
          </li>
        </ul>
        <div v-if="recommendList.length>0" class="headTitle">工人推荐</div>
        <div class="recommend" v-for="(item,index) in recommendList" :key="index"
             @click="detail(item.id, item.isMyPub)">
          <div class="paiHuoBox">
            <div class="headImg">
              <img class="headImg"
                   src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygwApplet/getJob/touxiang_default_lgsc.png"
                   v-if="!item.headImg">
              <img :src="item.headImg" v-else class="headImg">
            </div>
            <div class="person-info">
              <div class="work-name">
                <a class="recommend-title">
                  {{ item.name }}
                </a>
                <a v-if="item.workingAge" class="recommend-time">{{ item.workingAge }}年工龄</a>
              </div>
              <div class="tag-div">
                <!--                {{ item.infos }}-->
                <el-tag v-for="tag in item.infoarr">{{ tag }}</el-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {assignTaskList, recommendWorks} from '@api/paihuo'
import searchBox from '../components/searchBox'
import {getWxqr} from "@api/home";

export default {
  name: 'index',
  components: {
    searchBox
  },
  data() {
    return {
      appQrCode: 'http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/QRCode/app.png',
      xcxQrCode: 'http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/QRCode/xiaochengxu.jpg',
      qunQrCode: '',
      token: '',
      cityJson: {
        cityId: '320500',
        cityName: '苏州市'
      },
      searchVal: undefined,
      pageSize: 20,
      pageNum: 1,
      // 总条数
      total: 0,
      incomeListLoading: false,
      list: [],
      loadingGoods: true,
      ifHasProduct: false,
      cityValueList: [],
      workTypeValueList: [],
      pubDay: '',// 发布时间
      recommendList: []
    }
  },
  created() {
    let timestamp = Date.parse(new Date())
    this.appQrCode = this.appQrCode + '?time=' + timestamp
    this.xcxQrCode = this.xcxQrCode + '?time=' + timestamp

    if (localStorage.getItem('ygw-city')) {
      this.cityJson = JSON.parse(localStorage.getItem('ygw-city'))
    }

    this.cityValueList = [this.cityJson.cityId]

    if (this.$route.query.searchVal) {
      this.searchVal = this.$route.query.searchVal
    }
    if (this.$route.query.workerId) {
      this.workTypeValueList = [this.$route.query.workerId]
    }

    this.getAssignTaskList()
    this.token = localStorage.getItem('token')
    this.getWxqr()
    this.recommendWorks()
  },
  methods: {

    // 顶部搜索
    search(keyword) {
      this.searchVal = keyword
      this.total = 0
      this.getAssignTaskList()
    },

    // 根据地区获取微信二维码
    getWxqr() {
      getWxqr({
        cityCode: this.cityJson.cityId
      }).then(res => {
        if (res.data.code === 200) {
          this.qunQrCode = res.data.data.qrUrl
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 找活信息推荐
    recommendWorks() {
      recommendWorks({
        cityCode: this.cityJson.cityId
      }).then(res => {
        if (res.data.code === 200) {
          this.recommendList = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    searchList(data) {
      this.total = 0
      if (data.pubDay) {
        this.pubDay = data.pubDay
      }
      if (data.cityValueList) {
        this.cityValueList = data.cityValueList
      }
      if (data.workTypeValueList) {
        this.workTypeValueList = data.workTypeValueList
      }
      this.getAssignTaskList()
    },
    getAssignTaskList() {
      if (this.workTypeValueList) {
        var workTypes = this.workTypeValueList.toString()
      }
      if (this.cityValueList) {
        var cityValueList = this.cityValueList.toString()
      }
      var params = {
        content: this.searchVal,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        cityCode: cityValueList,
        typeWorks: workTypes,
        pubDay: this.pubDay === '0' ? '' : this.pubDay
      }
      this.loadingGoods = true
      assignTaskList(params).then(res => {
        if (res.data.code === 200) {
          this.loadingGoods = false
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.ifHasProduct = true
            this.list = res.data.data.rows
            this.total = res.data.data.totalRows
          } else {
            this.ifHasProduct = false
          }
          // 滚动到顶部
          window.scrollTo({
            'top': 0,
            'behavior': 'smooth'
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    detail(id, isMyPub) {
      console.log(id, isMyPub)
      if (isMyPub === 1) {
        this.enterRouter('getWorkAdvertising')
      } else {
        this.enterRouter('assignWorkDetail', {id: id})
      }
    },
  }
}
</script>

<style lang="scss">
.assignWork {
  padding-top: 16px;
  margin-bottom: 60px;

  .rightContainer {
    width: 368px;
    margin-left: 8px;

    li {
      border-radius: 8px;
      box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.0500);
      margin-bottom: 8px;

      img {
        width: 110px;
        height: 110px;
        margin: 12px 25px;
      }
    }

    .right-download-div {
      height: 140px;
      width: 365px;
      background-size: contain !important;
      cursor: pointer;
      left: -1px;
      color: #fff;
      font: 12px arial, simsun, sans-serif;
      padding-top: 3px;
    }

    .right-download-app {
      background: url(http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/getJob/right_download_app_lgsc@2x.png) no-repeat;
    }

    .right-download-xcx {
      background: url(http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/getJob/right_download_xiaochengxu_lgsc@2x.png) no-repeat;
    }

    .right-download-wechat {
      background: url(http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/getJob/right_download_wechat_lgsc@2x.png) no-repeat;
    }

    .headTitle {
      width: 100%;
      background: #EDF5FE;
      border-radius: 6px 6px 0px 0px;
      padding: 8px 11px;
      font-weight: bold;
      color: #333333;
      font-size: 16px;
    }

    .recommend:hover {
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.28);

      .zhao-gong-title, .title, .work-name {
        color: #37a0ff;
      }
    }

    .recommend {
      width: 100%;
      background: #fff;
      padding: 10px;

      .paiHuoBox {
        display: flex;

        .headImg {
          height: 55px;
          width: 55px;
          border-radius: 3px;
          margin-right: 5px;
        }
      }

      .recommend-title {
        width: 210px;
        font-size: 16px;
        height: 25px;
      }

      .recommend-time {
        text-align: right;
        width: 75px;
        font-size: 14px;
        height: 25px;
      }

      .tag-div {
        height: 24px;
        overflow: hidden;
      }

      &:not(last-child) {
        border-bottom: 1px solid #EEEEEE;
      }

      a {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
      }

      .el-tag {
        border-color: #096CEF;
        color: #096CEF !important;
        font-size: 12px;
        text-align: center;
        padding: 4px 10px;
        border-radius: 4px;
        margin-right: 8px;
        line-height: 14px;
        height: 23px;
        margin-bottom: 5px;
        //background: rgba(9, 108, 239, 0.0700);
        //font-size: 12px;
        //margin-right: 8px;
        //color: #096CEFFF;
        //height: 24px;
        //line-height: 23px;
      }

      .el-tag--plain.el-tag--info {
        color: #999;
      }
    }
  }
}

.paiHuo {
  width: 75%;

  .el-pager li, .el-pagination .btn-next, .el-pagination button:disabled, .el-pagination .btn-prev {
    background: none;
  }

  .el-pager li.active {
    background: #096cef;
    color: #fff;
  }

  .el-pager li {
    min-width: 20px;
    height: 20px;
    line-height: 20px;
    margin: 0 10px;
    font-size: 14px;
  }

  .el-pagination button {
    min-width: 20px;
    height: 20px;
    line-height: 20px;
  }

  .paiHuoBox {
    display: flex;
    align-items: center;

    .headImg {
      width: 56px;
      height: 56px;
      border-radius: 5px;
      margin-right: 8px;
    }

    .work-name {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 8px;
    }
  }

  .informationBox {
    display: flex;
    margin-top: 12px;

    .information {
      //flex: 1;
      color: #333333;
      font-size: 14px;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .intro {
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #999999;
    font-size: 14px;
    margin-top: 8px;
  }

  .mainContent:hover {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.28);

    .zhao-gong-title, .title, .work-name {
      color: #37a0ff;
    }

    //background: #FDFDFDCF;
  }

  .mainContent {
    padding: 13px;
    margin-bottom: 8px;
    position: relative;
    background: #fff;
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.0500);
    border-radius: 6px;
  }

  .btn-chat {
    position: absolute;
    right: 16px;
    top: 24px;
  }

  .icon_zhiding {
    width: 39px;
    height: 39px;
    background: url("http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygw_web/getJob/icon_zhiding.png") center no-repeat;
    background-size: contain;
    position: absolute;
    left: 0;
    top: 0;
  }

  .tag-div {
    font-size: 12px;
    height: 24px;
    line-height: 24px;

    .el-tag {
      border-color: #096CEF;
      color: #096CEF;
      font-size: 12px;
      text-align: center;
      padding: 4px 10px;
      border-radius: 4px;
      margin-right: 8px;
      line-height: 14px;
      height: 23px;
    }

    .el-tag--plain.el-tag--info {
      color: #999;
    }
  }
}

</style>
